import React from 'react';
import axios from 'axios';
import { Button, ControlLabel, Form, FormGroup, Glyphicon, Col, Row, Tooltip, OverlayTrigger, FormControl } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Select from 'react-select';
import Loader from 'react-loader';
import WorkflowHeaderDetails from './WorkflowHeaderDetails';
import ProviderSearchModal from '../../Shared/ProviderSearchModal';
import { concat } from 'lodash';

class CbsReport extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            providerID: '',
            selectedProvider: '',
            practiceGroupingID: '',
            selectedPractice: '',
            cbsReport: [],
            printCbsReportList: [],
            filteredCbsReportList: [],
            practiceSearchResults: [],
            practiceProviders: [],
            practicePrintProviderList: [],
            //selected providers for cbs report
            selectedProviders: [],
            showProviderModal: false,
            //selected providers for print list
            selectedPrintProviders: [],
            filterActive: false,
            filteredCbsReportList: []

        };
        this.addTooltip = (
            <Tooltip id="add"><strong>Add CBS</strong></Tooltip>
        );
        this.removeTooltip = (
            <Tooltip id="remove"><strong>Remove CBS</strong></Tooltip>
        );
    }

    componentWillMount() {
        // set provider id and practice group id when navigating between pages
        if (this.props.provider.id && this.props.practice.groupingID) {
            this.getPracticeProviders();
            this.setState({
                providerID: this.props.provider.id,
                practiceGroupingID: this.props.practice.groupingID,
                selectedProvider: this.props.provider.desc + ' - ' + this.props.provider.id,
                selectedPractice: this.props.practice.desc,
            });

        }
        if (this.props.packageID) {
            this.getOpenCbsReportWorkflows(this.state.selectedProviders);
            this.getIncludedCbsReportWorkflows();
        }
    }

    componentWillReceiveProps(nextProps) {
        // set provider id and practice grouping id when refreshing the page
        if (nextProps.provider.id > 0 && nextProps.practice.groupingID) {
            this.getPracticeProviders();
            this.setState({
                providerID: nextProps.provider.id,
                practiceGroupingID: nextProps.practice.groupingID,
                selectedProvider: nextProps.provider.desc + ' - ' + nextProps.provider.id,
                selectedPractice: nextProps.practice.desc
            });
        }
        if (this.props.packageID) {
            this.getOpenCbsReportWorkflows(this.state.selectedProviders);
            this.getIncludedCbsReportWorkflows();
        }
    }

    componentDidMount() {
        this.setState({ loaded: true });
        if (this.props.provider.id && this.props.practice.groupingID) {
            this.getPracticeProviders();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.practice.groupingID !== this.props.practice.groupingID) {
            this.getPracticeProviders();
        }
        //based on print list data changed provider dropdown option needs to update
        const printListChanged = prevState.printCbsReportList !== this.state.printCbsReportList;
        if (printListChanged) {
            this.UpdatePracticeProviders();
        }
        //based on print list data or slected option changed print list needs to update
        if (prevState.selectedPrintProviders !== this.state.selectedPrintProviders || printListChanged) {
            this.updateFilterProvider();
        }
    }

    getOpenCbsReportWorkflows = (providerIds) => {
        if (providerIds && providerIds.length > 0) {
            axios.post('/packages/' + this.props.packageID + '/OpenCBSWorkflows', providerIds)
                .then(response => {
                    this.setState({
                        cbsReport: response.data
                    })
                })
                .catch((error) => {
                    this.props.toast('error', 'Could not load open cbs.', 'Error');
                });
        }

    }

    getIncludedCbsReportWorkflows = () => {
        // print cbs report api
        axios.get('/packages/' + this.props.packageID + '/IncludedCBSWorkflows')
            .then(response =>
                this.setState({
                    printCbsReportList: response.data
                }))
            .catch((error) => {
                this.props.toast('error', 'Could not load included queries.', 'Error');
            });
    }

    //common methods to filter out provider option list based on print list
    buildPracticePrintProviderList = (mappedProviders = [], printList = []) => {
        const providerIdsFromPrintList = printList.map(item => String(item.providerID).trim());
        return mappedProviders.filter(p => providerIdsFromPrintList.includes(String(p.value)));
    };

    getPracticeProviders = (groupingID = this.props.practice.groupingID) => {
        axios.get(`/practice/${groupingID}/provider`)
            .then((response) => {
                const practiceProviders = response.data.systemEntered.concat(response.data.userEntered);
                const practiceProviderList = practiceProviders.map((x) => {
                    return {
                        label: x.lastName + " " + x.firstName,
                        value: x.internalKey
                    };
                });

                const practicePrintProviderList = this.buildPracticePrintProviderList(
                    practiceProviderList,
                    this.state.printCbsReportList
                );
                this.setState({ practiceProviders: practiceProviderList, practicePrintProviderList: practicePrintProviderList });
            })
            .catch((error) => {
                this.state.toast('error', 'Could not load provider data.', 'Error');
            });
    }
    UpdatePracticeProviders = () => {

        const practicePrintProviderList = this.buildPracticePrintProviderList(
            this.state.practiceProviders,
            this.state.printCbsReportList
        );
        this.setState({ practicePrintProviderList: practicePrintProviderList });
    }
    updateFilterProvider = () => {
        const filteredCbsReportList = this.state.printCbsReportList?.filter(row =>
            this.state.selectedPrintProviders.includes(Number(row.providerID))
        );
        this.setState({
            filteredCbsReportList: filteredCbsReportList,
        });
    }

    workflowIsNotContainedInWorkflowList = (workflowList) => (workflow) => {
        const workflowIsContainedInResponse = workflowList
            .filter(addedWorkflow =>
                addedWorkflow.cdiAlertCBSReportId === workflow.cdiAlertCBSReportId)
            .length;
        return !workflowIsContainedInResponse;
    }

    handleAddAllUndelivered = () => {
        //  included cbs report api,then update print list from response and filter out cbs report
        axios.post('/packages/' + this.props.packageID + '/IncludedCBSWorkflows',
            this.state.cbsReport
                .filter(item => item.reportStatus == 'Generated')
                .map(item => item.cdiAlertCBSReportId))
            .then(response => {
                const allowedProviderList = this.buildPracticePrintProviderList(
                    this.state.practiceProviders,
                    response.data
                );
                const providerIdList = new Set([
                    ...(this.state.selectedProviders || []),
                    ...(this.state.selectedPrintProviders || []),
                ]);
                const selectedPrintProviders = Array.from(providerIdList).filter(id =>
                    allowedProviderList.some(p => String(p.value) === String(id))
                );
                this.setState({
                    printCbsReportList: response.data,
                    selectedPrintProviders: selectedPrintProviders,
                    practicePrintProviderList: allowedProviderList,
                    cbsReport: [...this.state.cbsReport]
                        .filter(this.workflowIsNotContainedInWorkflowList(response.data))
                })

            }
            )
            .catch((error) => {
                this.props.toast('error', 'Could not add CBS.', 'Error');
            });
    }

    handleAddAll = () => {
        //  included cbs report api,then update print list from response and reset cbs report as empty
        axios.post('/packages/' + this.props.packageID + '/IncludedCBSWorkflows',
            this.state.cbsReport.map(item => item.cdiAlertCBSReportId))
            .then((response) => {
                const printList = Array.isArray(response?.data) ? response.data : [];

                const allowedProviderList = this.buildPracticePrintProviderList(
                    this.state.practiceProviders || [],
                    printList
                );
                const providerIdList = new Set([
                    ...(this.state.selectedProviders || []),
                    ...(this.state.selectedPrintProviders || []),
                ]);
                const selectedPrintProviders = Array.from(providerIdList).filter(id =>
                    allowedProviderList.some(p => String(p.value) === String(id))
                );
                this.setState({
                    cbsReport: [],
                    selectedPrintProviders: selectedPrintProviders,
                    practicePrintProviderList: allowedProviderList,
                    printCbsReportList: printList,
                })
            }

            )
            .catch((error) => {
                this.props.toast('error', 'Could not add cbs.', 'Error');
            });
    }

    clearList = () => {
        const cdiAlertCBSReportIds = this.refs.printCbsReportList.state.data.map(item => { return item.cdiAlertCBSReportId });
        // Move all lines from print list to cbs report list
        axios.post('/packages/' + this.props.packageID + '/RemoveIncludedCBSWorkflows', cdiAlertCBSReportIds)
            .then(response => {
                this.getOpenCbsReportWorkflows(this.state.selectedProviders);
                this.getIncludedCbsReportWorkflows();
                this.setState({ filteredCbsReportList: [] })
            })
            .catch((error) => {
                this.props.toast('error', 'Could not remove CBS.', 'Error');
            });
    }

    clearFilter = () => {
        this.setState({
            selectedPrintProviders: [],
            filteredCbsReportList: [],
        });
    };

    handleAddMemberCbs = (rowIndex) => {
        const cdiAlertCBSReportId = this.refs.cbsReportTable.state.data[rowIndex].cdiAlertCBSReportId;
        // Move the cbs line from the cbs table to the print list table
        axios.post('/packages/' + this.props.packageID + '/IncludedCBSWorkflows', [cdiAlertCBSReportId])
            .then((response) => {
                const printList = Array.isArray(response?.data) ? response.data : [];
                const selectedPrintProvider = printList
                    .filter((item) => Number(item.cdiAlertCBSReportId) === Number(cdiAlertCBSReportId))
                    .map(item => Number(item.providerID));
                const selectedPrintProviders = Array.from(new Set([
                    ...(selectedPrintProvider),
                    ...(this.state.selectedPrintProviders || []),
                ]));
                this.setState({
                    printCbsReportList: response.data,
                    selectedPrintProviders: selectedPrintProviders,
                    cbsReport: [...this.state.cbsReport]
                        .filter(this.workflowIsNotContainedInWorkflowList(response.data))
                })
            })
            .catch((error) => {
                this.props.toast('error', 'Could not add cbs.', 'Error');
            });
    }

    handleRemoveMemberCbs = (rowIndex) => {
        const cdiAlertCBSReportId = [this.refs.printCbsReportList.state.data[rowIndex].cdiAlertCBSReportId];
        // Move the cbs line from the print list table to the cbs report table
        axios.post('/packages/' + this.props.packageID + '/RemoveIncludedCBSWorkflows', cdiAlertCBSReportId)
            .then(response => {
                this.getOpenCbsReportWorkflows(this.state.selectedProviders);
                this.getIncludedCbsReportWorkflows();
            })
            .catch((error) => {
                this.props.toast('error', 'Could not remove query.', 'Error');
            });
    }

    handleProviderChange = (selectedOptions) => {
        // Extract provider IDs (label contains providerID as per  mapping)
        const providerIds = selectedOptions ? selectedOptions.map(opt => opt.value) : [];
        // Save selection if needed
        this.setState({ selectedProviders: providerIds }, () => {
            // Call method to refresh cbs report
            this.getOpenCbsReportWorkflows(providerIds);
        });
    };

    handleFilterProviderChange = (selectedOptions) => {
        // Extract provider IDs (label contains providerID as per  mapping)
        const providerIds = selectedOptions ? selectedOptions.map(opt => opt.value) : [];
        this.setState(prev => ({
            selectedPrintProviders: providerIds,
        }));
    };
    filterProvider = (selectedOptions) => {
        // clear filter
        if (!selectedOptions || (Array.isArray(selectedOptions) && selectedOptions.length === 0)) {
            this.setState({
                selectedPrintProviders: selectedOptions || null,
                filteredCbsReportList: [],
                filterActive: false,
            });
            return;
        }
        // Normalize to an array of selected IDs (strings)
        const selectedIds = Array.isArray(selectedOptions)
            ? selectedOptions.map(o => String(o?.value ?? o).trim())
            : [String(selectedOptions?.value ?? selectedOptions).trim()];

        this.setState(prev => ({
            selectedPrintProviders: selectedOptions,
            filteredCbsReportList: prev.printCbsReportList.filter(row =>
                selectedIds.includes(String(row.providerID).trim())
            ),
            filterActive: true,
        }));
    };

    formatDateString = (date) => {
        return date ? new Date(date).toLocaleDateString('en-US', { timeZone: 'UTC' }) : '';
    }

    formatCDIAlertWorkflowLink = (cdiAlertCBSReportId) => {
        return <a target='_blank' href={`/cdi/${cdiAlertCBSReportId}/viewonly?isPECAddAlert=true`} rel="noopener noreferrer">{cdiAlertCBSReportId}</a>;
    }

    toggleProviderSearchModal = () => {
        this.setState({ showProviderModal: !this.state.showProviderModal });
    }

    render() {

        const customQuerySelect = (props) => {
            const rowIndex = props.rowIndex;
            if (rowIndex === 'Header') {
                return null;
            } else {
                return (
                    <div>
                        <OverlayTrigger placement="top" overlay={this.addTooltip}>
                            <Button onClick={(e) => {
                                e.stopPropagation();
                                this.handleAddMemberCbs(rowIndex)
                            }
                            }>
                                <Glyphicon glyph="plus" />
                            </Button>
                        </OverlayTrigger>
                    </div>
                );
            }
        };

        const customprintCbsReportListSelect = (props) => {
            const rowIndex = props.rowIndex;
            if (rowIndex === 'Header') {
                return null;
            } else {

                return (
                    <div>
                        <OverlayTrigger placement="top" overlay={this.removeTooltip}>
                            <Button onClick={() => this.handleRemoveMemberCbs(props.rowIndex)}>
                                <Glyphicon glyph="trash" />
                            </Button>
                        </OverlayTrigger>
                    </div>
                );
            }
        };

        const selectQueryRow = {
            mode: 'radio',
            customComponent: customQuerySelect,
            columnWidth: '7rem'
        };

        const selectPrintListRow = {
            mode: 'radio',
            customComponent: customprintCbsReportListSelect,
            columnWidth: '7rem'
        };

        return (
            <div>
                <Row>
                    <Col sm={12}>
                        <h3 className="workflow-title">CBS Report Selection</h3>
                        {
                            this.state.loaded &&
                            <WorkflowHeaderDetails provider={this.props.provider.desc + ' (' + this.props.provider.id + ')'} practice={this.props.practice.desc} packageType={this.props.packageType} />
                        }
                        <hr />
                    </Col>
                </Row>
                <Row style={{ marginBottom: '2rem', alignItems: 'center', display: 'flex' }}>
                    <Col sm="auto" style={{ display: 'flex', alignItems: 'center' }}>
                        <ControlLabel style={{ marginLeft: '1rem', marginBottom: 0 }}>Provider</ControlLabel>
                    </Col>
                    <Col sm={4}>
                        <Select
                            multi
                            value={this.state.selectedProviders}
                            options={this.state.practiceProviders}
                            placeholder="Select Provider"
                            styles={{ container: (base) => ({ ...base, marginRight: '2rem' }) }}
                            onChange={this.handleProviderChange}

                        />
                    </Col>
                </Row>

                <Row style={{ minHeight: '720px' }}>
                    <Col sm={12}>
                        <Loader loaded={this.state.loaded}>
                            <Row>
                                <Col sm={12}>
                                    <Form inline>
                                        <FormGroup>
                                            <ControlLabel style={{ fontSize: '18px', marginBottom: '1.4rem' }}>CBS Report List</ControlLabel>
                                            <Button style={{ marginBottom: '1.4rem', marginLeft: '4rem' }} onClick={this.handleAddAllUndelivered}>Add All Undelivered</Button>
                                            <Button style={{ marginBottom: '1.4rem', marginLeft: '1.4rem' }} onClick={this.handleAddAll}>Add All</Button>
                                        </FormGroup>
                                    </Form>
                                    <BootstrapTable
                                        data={this.state.cbsReport}
                                        ref="cbsReportTable"
                                        hover
                                        striped
                                        condensed
                                        keyField="cdiAlertCBSReportId"
                                        selectRow={selectQueryRow}
                                        pagination
                                    >
                                        <TableHeaderColumn
                                            dataField="cdiAlertCBSReportId"
                                            hidden
                                        >
                                            ID
                                        </TableHeaderColumn>

                                        <TableHeaderColumn dataField="alertId" dataSort>
                                            Alert ID
                                        </TableHeaderColumn>
                                        <TableHeaderColumn dataField="memberName" dataSort>
                                            Member Name
                                        </TableHeaderColumn><TableHeaderColumn dataField="memberID" dataSort>
                                            Member ID
                                        </TableHeaderColumn>
                                        <TableHeaderColumn dataField="dateOfServiceFrom" dataSort dataFormat={this.formatDateString}>
                                            DOS From
                                        </TableHeaderColumn>
                                        <TableHeaderColumn dataField="dateOfServiceTo" dataSort dataFormat={this.formatDateString}>
                                            DOS Thru
                                        </TableHeaderColumn>
                                        <TableHeaderColumn dataField="providerName" dataSort>
                                            Provider Name
                                        </TableHeaderColumn>
                                        <TableHeaderColumn dataField="providerNPI" dataSort>
                                            Provider NPI
                                        </TableHeaderColumn>
                                        <TableHeaderColumn dataField="diagnosisCode" dataSort>
                                            Diagnosis Code
                                        </TableHeaderColumn>
                                        <TableHeaderColumn dataField="diagnosisDescription" dataSort>
                                            Diagnosis Description
                                        </TableHeaderColumn>
                                        <TableHeaderColumn dataField="reportStatus" dataSort>
                                            Status
                                        </TableHeaderColumn>
                                        <TableHeaderColumn dataField="diagCreatedDatetime" dataSort dataFormat={this.formatDateString}>
                                            Created Date
                                        </TableHeaderColumn>
                                    </BootstrapTable>
                                </Col>
                            </Row>
                            <Row>
                                <br></br>
                                <Col sm={12}>
                                    <Row style={{ marginBottom: '2rem', alignItems: 'center', display: 'flex' }}>
                                        <Col sm="auto" style={{ display: 'flex', alignItems: 'center' }}>
                                            <ControlLabel style={{ marginLeft: '1rem', marginBottom: 0 }}>Provider</ControlLabel>
                                        </Col>
                                        <Col sm={4}>
                                            <Select
                                                multi
                                                value={this.state.selectedPrintProviders}
                                                options={this.state.practicePrintProviderList}
                                                placeholder="Select Provider"
                                                styles={{ container: (base) => ({ ...base, marginRight: '2rem' }) }}
                                                onChange={this.handleFilterProviderChange}

                                            />
                                        </Col>
                                    </Row>
                                    <Form inline style={{ marginTop: '4rem' }}>
                                        <FormGroup>
                                            <ControlLabel style={{ fontSize: '18px', marginBottom: '1.4rem' }}>Print List</ControlLabel>
                                            <Button style={{ marginBottom: '1.4rem', marginLeft: '3.2rem' }} onClick={this.clearList}>
                                                <Glyphicon glyph="trash" style={{ marginRight: '0.6rem' }} />Clear List
                                            </Button>
                                        </FormGroup>
                                    </Form>
                                    <BootstrapTable
                                        data={this.state.filteredCbsReportList}
                                        ref="printCbsReportList"
                                        hover
                                        striped
                                        condensed
                                        keyField="cdiAlertCBSReportId"
                                        selectRow={selectPrintListRow}
                                        pagination
                                    >
                                        <TableHeaderColumn
                                            dataField="cdiAlertCBSReportId"
                                            hidden
                                        >
                                            ID
                                        </TableHeaderColumn>
                                        <TableHeaderColumn dataField="alertId" dataSort>
                                            Alert ID
                                        </TableHeaderColumn>
                                        <TableHeaderColumn dataField="memberName" dataSort>
                                            Member Name
                                        </TableHeaderColumn>
                                        <TableHeaderColumn dataField="memberID" dataSort>
                                            Member ID
                                        </TableHeaderColumn>
                                        <TableHeaderColumn dataField="dateOfServiceFrom" dataSort dataFormat={this.formatDateString}>
                                            DOS From
                                        </TableHeaderColumn>
                                        <TableHeaderColumn dataField="dateOfServiceTo" dataSort dataFormat={this.formatDateString}>
                                            DOS Thru
                                        </TableHeaderColumn>
                                        <TableHeaderColumn dataField="providerName" dataSort>
                                            Provider Name
                                        </TableHeaderColumn>
                                        <TableHeaderColumn dataField="providerNPI" dataSort>
                                            Provider NPI
                                        </TableHeaderColumn>
                                        <TableHeaderColumn dataField="diagnosisCode" dataSort>
                                            Diagnosis Code
                                        </TableHeaderColumn>
                                        <TableHeaderColumn dataField="diagnosisDescription" dataSort>
                                            Diagnosis Description
                                        </TableHeaderColumn>
                                        <TableHeaderColumn dataField="reportStatus" dataSort>
                                            Status
                                        </TableHeaderColumn>
                                        <TableHeaderColumn dataField="diagCreatedDatetime" dataSort dataFormat={this.formatDateString}>
                                            Created Date
                                        </TableHeaderColumn>
                                    </BootstrapTable>

                                </Col>
                            </Row>
                        </Loader>
                    </Col>
                </Row>

            </div>
        );
    }
}

export default CbsReport;
